import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import Select from 'react-select'

import { httpOk, GET, POST, PUT } from 'helpers/api'

function Index() {
	const { t } = useTranslation()

	const [data, setData] = useState({
		'id': "",
		'token': "",
		'map_typ_id': "",
	})
	const [mapTypes, setMapTypes] = useState([])

	async function searchWithFilter() {
		var filterUrl = `/chain/maps`

		var response = await GET(filterUrl, {}, { loader: true })
		if (httpOk(response)) setData(response.data);
	}

	async function createUpdate(e) {
		e.preventDefault()

		var response;
		if (data.id) {
			response = await PUT('/chain/maps', data, { loader: true })
		} else {
			response = await POST('/chain/maps', data, { loader: true })
			if (httpOk(response)) searchWithFilter()
		}

		if (httpOk(response)) { }
	}

	async function getMapTypes() {
		const response = await GET('/helper/map-types')
		if (httpOk(response)) setMapTypes(response.data)
	}

	useEffect(() => {
		searchWithFilter()
		getMapTypes()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<div className="d-flex text-truncate">
					<h4 className="vertical-center">
						{t('geocoding')}
					</h4>
				</div>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="row">
						<div className="col-md-4">
							<div className="form-group">
								<label>{t('type')}</label>
								<Select
									options={mapTypes}
									value={mapTypes.find(option => option.id === data.map_type_id) || ''}
									onChange={(option) => setData({ ...data, 'map_type_id': option.id, 'website': option.website })}
									placeholder=""
									noOptionsMessage={() => t('list_empty')}
									getOptionLabel={(option) => option.name}
									getOptionValue={(option) => option.id}
								/>
							</div>

							<div className="d-flex gap-2">
								<p>{t('website')}:</p>
								<Link to={data.website}>
									{data.website}
								</Link>
							</div>

							<div className="form-group">
								<label>TOKEN</label>
								<input type="text" className="form-control" name="token"
									autoComplete="off"
									value={data.token ?? ''}
									onChange={(e) => setData({ ...data, 'token': e.target.value })} />
							</div>
						</div>
					</div>

					<div className="btn-wrapper gap-2">
						<Link className="btn btn-warning btn-rounded btn-wide" to="/external-integrations">
							{t('cancel')}
						</Link>
						<button type="button" className="btn btn-primary btn-rounded btn-wide"
							onClick={(e) => createUpdate(e)}>
							{t('save')}
						</button>
					</div>
				</div>
			</div>
		</>
	)
}

export default Index